import { Button, styled } from '@mui/material';

const StyledButton = styled(Button)(() => ({
  background: '#6d77c8',
  borderRadius: '32px',
  padding: '8px 24px',
  color: '#ffffff',
  textTransform: 'none',
  fontWeight: 700,
  fontFamily: '"Inter", sans-serif',
  '&:disabled': {
    color: '#ffffff',
    opacity: 0.5,
  },
  '&:hover': {
    backgroundColor: '#575fa0',
  },
}));

export default StyledButton;
